import getExtensionFromPath from '../getExtensionFromPath';
import isStreamVideo from '../is/isStreamVideo';
import isSupportedCodec from '../is/isSupportedCodec';

var canPlayOriginaVideo = function canPlayOriginaVideo(videos) {
  var isMp4 = function isMp4(video) {
    return getExtensionFromPath(video.path) === 'mp4';
  };

  var isHLS = function isHLS(video) {
    return isStreamVideo(video.path);
  };

  var originalVideo = videos.filter(function (v) {
    return v.isOriginal;
  })[0];
  if (!originalVideo) return false;
  var canPlayOriginal = originalVideo.codec ? isSupportedCodec(originalVideo) : isMp4(originalVideo) || isHLS(originalVideo);
  return canPlayOriginal;
};

export default canPlayOriginaVideo;